var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large terms-of-use-container"
  }, [_c("BackgroundVideo"), _c("div", {
    staticClass: "container-centered small"
  }, [_c("TermsOfUseComponent")], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };